<template>
  <v-card class="notification-card">
    <div class="notification-header pa-3 d-flex align-center">
      <h3 class="text-h6 font-weight-bold">Benachrichtigungen</h3>
      <v-spacer></v-spacer>
      <v-btn v-if="hasUnread" icon small @click="$emit('mark-all-read')" title="Alle als gelesen markieren">
        <v-icon color="white" size="20">mdi-check-all</v-icon>
      </v-btn>
      <v-btn small @click="$router.push('/user')" dark outlined title="Zum Profil">
        <v-icon color="white" size="20">mdi-cog-outline</v-icon>
        <span color="white">Profil</span>
      </v-btn>
    </div>

    <v-divider></v-divider>

    <div v-if="notifications.length === 0 && !showPushCta" class="empty-state text-center pa-8">
      <v-icon class="empty-state-icon mb-4">mdi-bell-off-outline</v-icon>
      <p class="font-weight-medium">Du hast keine neuen Nachrichten</p>
      <span class="caption">Hier siehst du Updates zu Kursen, Freunden und mehr.</span>
    </div>

    <v-list v-else class="notification-list pa-0">
      <v-list-item
        v-for="notification in notifications"
        :key="notification._id"
        @click="$emit('notification-click', notification)"
        class="notification-item"
        :class="{ unread: !notification.read }">
        <v-list-item-avatar class="notification-icon-wrapper" size="40">
          <v-icon :color="!notification.read ? 'primary' : 'grey'">mdi-bell-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold white--text" v-text="notification.title"></v-list-item-title>
          <v-list-item-subtitle class="white--text" v-text="notification.text"></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action-text class="caption white--text">
          {{ formatTime(notification.createdAt) }}
        </v-list-item-action-text>
      </v-list-item>
    </v-list>

    <div v-if="showPushCta" class="notification-footer pa-4">
      <div class="push-cta">
        <div class="push-cta-content">
          <h4 class="push-cta-title">Bleib auf dem Laufenden!</h4>
          <p class="push-cta-text">Erhalte wichtige Updates direkt auf dein Gerät.</p>
        </div>
        <v-btn color="primary" class="font-weight-bold" depressed @click="$emit('enable-push')"> Push aktivieren </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    notifications: {
      type: Array,
      required: true,
    },
    showPushCta: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasUnread() {
      return this.notifications.some((n) => !n.read)
    },
  },
  methods: {
    formatTime(createdAt) {
      // Using a simple time formatter, assuming moment.js is globally available or you can import it
      // This makes the component more self-contained.
      if (this.$moment) {
        return this.$moment(createdAt).fromNow(true)
      }
      return createdAt
    },
  },
}
</script>

<style scoped>
::v-deep .notification-menu {
  background-color: transparent !important;
  backdrop-filter: blur(15px) saturate(180%);
  -webkit-backdrop-filter: blur(15px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px !important;
  overflow: hidden;
}

.notification-card {
  background-color: rgba(30, 30, 30, 0.9) !important;
  color: #f1f1f1;
  width: 360px;
  max-height: 50vh;
  display: flex;
  flex-direction: column;

  .notification-header {
    flex-shrink: 0;
    h3 {
      color: #ffffff;
    }
  }

  .v-divider {
    border-color: rgba(255, 255, 255, 0.1) !important;
  }
}

.notification-list {
  overflow-y: auto;
  background: transparent !important;
  flex-grow: 1;
}

.notification-item {
  padding: 12px 16px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }

  &.unread {
    background-color: rgba(86, 88, 243, 0.1);
    border-left: 3px solid var(--v-primary);
  }

  .notification-icon-wrapper {
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    margin-right: 16px !important;
  }

  .v-list-item__title {
    line-height: 1.3;
    margin-bottom: 2px;
  }

  .v-list-item__subtitle {
    font-size: 0.85rem;
    color: #b0b0b0;
    white-space: normal;
  }

  .v-list-item__action-text {
    color: #888;
  }
}

.empty-state {
  color: #a0a0a0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .empty-state-icon {
    font-size: 4rem !important;
    color: rgba(255, 255, 255, 0.15);
  }
}

.notification-footer {
  flex-shrink: 0;
  background-color: rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.push-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, rgba(86, 88, 243, 0.2) 0%, rgba(86, 88, 243, 0.05) 100%);
  padding: 12px 16px;
  border-radius: 12px;

  &-title {
    font-size: 1rem;
    font-weight: 700;
    color: #fff;
  }
  &-text {
    font-size: 0.8rem;
    color: #c0c0c0;
    margin: 0;
  }
}
</style>
